import groupBy from 'lodash/groupBy'
import uniq from 'lodash/uniq'

import type { Shift, ShiftsRow, View } from 'modules/shift_management/lib/types'

interface FormDataReturnProps {
  employeeIds: number[]
  newShiftsRowsKeys: string[]
  shiftsReferenceKeys: string[]
}

const buildEmployeeIds = (
  view: View,
  shiftsRows: ShiftsRow[],
  newShifts: Shift[]
): FormDataReturnProps => {
  const groupedShifts = groupBy(newShifts, (shift: Shift) => shift.rowKeyReference(view))
  const shiftsReferenceKeys = uniq(Object.keys(groupedShifts))
  const existingShiftsRowsKeys = new Set(shiftsRows.map((s: ShiftsRow) => s.key))
  const newShiftsRowsKeys = shiftsReferenceKeys.filter((s) => !existingShiftsRowsKeys.has(s))
  const employeeIds = uniq(
    newShiftsRowsKeys.flatMap((key) => groupedShifts[key]!.map((s: Shift) => s.employeeId))
  )

  return {
    employeeIds,
    newShiftsRowsKeys,
    shiftsReferenceKeys,
  }
}

export default buildEmployeeIds
